<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510"><path d="M510 52.5v-30H355.73l-315 195H0v30h30v150H0v90h510v-270h-30v-165zm-195 165v60h-45V110.86l75-46.43V217.5zm-105 60v60h-45V175.86l75-46.43V277.5zM60 240.86l75-46.43V337.5h-30v60H60zM480 457.5H30v-30h105v-60h105v-60h105v-60h135zm-30-240h-75v-165h75z"/></svg>
</template>
